import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import { trackWindowScroll } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const FeaturedServices = ({ scrollPosition }) => {
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const sectionElement = document.getElementById('featured-services');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => setIsInView(entry.isIntersecting));
      },
      { threshold: 0.1 },
    );

    if (sectionElement) observer.observe(sectionElement);

    return () => {
      if (sectionElement) observer.unobserve(sectionElement);
    };
  }, []);

  const sectionStyle = {
    transition: 'opacity 0.5s ease, transform 0.5s ease',
    opacity: isInView ? 1 : 0,
    transform: isInView ? 'translateY(0)' : 'translateY(20px)',
    visibility: isInView ? 'visible' : 'hidden',
  };
  return (
    <section
      id="featured-services"
      className="featured-services section"
      style={sectionStyle}
    >
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>Fasilitas</h2>
        <p>
          Kami menyediakan fasilitas kesehatan modern dan lengkap untuk
          mendukung kebutuhan kesehatan Anda secara menyeluruh.
        </p>
      </div>
      {/* End Section Title */}

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row gy-5">
          <div
            className="col-xl-4 col-md-6"
            data-aos="zoom-in"
            data-aos-delay="200"
          >
            <div className="service-item">
              <div className="img">
                <img
                  src="/img/fasilitas/CT_SCAN-1024.webp"
                  srcSet="/img/fasilitas/CT_SCAN-256.webp 256w,
                      /img/fasilitas/CT_SCAN-512.webp 512w,
                      /img/fasilitas/CT_SCAN-1024.webp 1024w"
                  sizes="(max-width: 768px) 100vw, 50vw"
                  className="img-fluid"
                  alt="CT SCAN 128 SLICE CARDIO"
                  effect="blur"
                  width="1024"
                  height="512"
                  loading="lazy"
                  scrollPosition={scrollPosition}
                />
              </div>
              <div className="details position-relative">
                <div className="icon">
                  <Icon icon="mdi:radiology-box-outline" />
                </div>
                <Link to="/ctscan" className="stretched-link">
                  <h3>CT-SCAN 128 SLICE CARDIO</h3>
                </Link>
                <p>
                  Layanan CT-Scan dengan teknologi 128 slice untuk pemeriksaan
                  jantung mendetail, memberikan hasil yang akurat dan cepat.
                </p>
              </div>
            </div>
          </div>

          <div
            className="col-xl-4 col-md-6"
            data-aos="zoom-in"
            data-aos-delay="300"
          >
            <div className="service-item">
              <div className="img">
                <img
                  src="/img/fasilitas/RONTGEN_D-R_C-R-1024.webp"
                  srcSet="/img/fasilitas/RONTGEN_D-R_C-R-256.webp 256w,
                    /img/fasilitas/RONTGEN_D-R_C-R-512.webp 512w,
                    /img/fasilitas/RONTGEN_D-R_C-R-1024.webp 1024w"
                  sizes="(max-width: 768px) 100vw, 50vw"
                  className="img-fluid"
                  alt="RONTGEN D-R & C-R"
                  width="1024"
                  height="512"
                  loading="lazy"
                  scrollPosition={scrollPosition}
                />
              </div>
              <div className="details position-relative">
                <div className="icon">
                  <Icon icon="healthicons:xray-outline" />
                </div>
                <Link to="/rontgen" className="stretched-link">
                  <h3>RONTGEN D-R & C-R</h3>
                </Link>
                <p>
                  Layanan rontgen digital dan konvensional untuk berbagai
                  kebutuhan radiologi, memungkinkan identifikasi kondisi tulang,
                  dada, dan organ internal dengan cepat.
                </p>
              </div>
            </div>
          </div>

          <div
            className="col-xl-4 col-md-6"
            data-aos="zoom-in"
            data-aos-delay="400"
          >
            <div className="service-item">
              <div className="img">
                <img
                  src="/img/fasilitas/MAMMOGRAFI-1024.webp"
                  srcSet="/img/fasilitas/MAMMOGRAFI-256.webp 256w,
                      /img/fasilitas/MAMMOGRAFI-512.webp 512w,
                      /img/fasilitas/MAMMOGRAFI-1024.webp 1024w"
                  sizes="(max-width: 768px) 100vw, 50vw"
                  className="img-fluid"
                  alt="MAMMOGRAFI"
                  width="1024"
                  height="512"
                  loading="lazy"
                  scrollPosition={scrollPosition}
                />
              </div>
              <div className="details position-relative">
                <div className="icon">
                  <Icon icon="medical-icon:i-mammography" />
                </div>
                <Link to="/mammografi" className="stretched-link">
                  <h3>MAMMOGRAFI</h3>
                </Link>
                <p>
                  Pemeriksaan mammografi modern untuk deteksi dini kelainan pada
                  jaringan payudara, membantu diagnosis kanker payudara dan
                  kondisi terkait.
                </p>
              </div>
            </div>
          </div>

          <div
            className="col-xl-4 col-md-6"
            data-aos="zoom-in"
            data-aos-delay="500"
          >
            <div className="service-item">
              <div className="img">
                <img
                  src="/img/fasilitas/USG_4_DIMENSI-1024.webp"
                  srcSet="/img/fasilitas/USG_4_DIMENSI-256.webp 256w,
          /img/fasilitas/USG_4_DIMENSI-512.webp 512w,
          /img/fasilitas/USG_4_DIMENSI-1024.webp 1024w"
                  sizes="(max-width: 768px) 100vw, 50vw"
                  className="img-fluid"
                  alt="USG 4 DIMENSI"
                  width="1024"
                  height="512"
                  loading="lazy"
                  scrollPosition={scrollPosition}
                />
              </div>
              <div className="details position-relative">
                <div className="icon">
                  <Icon icon="medical-icon:ultrasound" />
                </div>
                <Link to="/usg" className="stretched-link">
                  <h3>USG 4 DIMENSI</h3>
                </Link>
                <p>
                  Alat USG 4D untuk memantau perkembangan janin secara real-time
                  dengan visualisasi detail, mempermudah dokter dan ibu dalam
                  pemantauan kehamilan.
                </p>
              </div>
            </div>
          </div>

          <div
            className="col-xl-4 col-md-6"
            data-aos="zoom-in"
            data-aos-delay="600"
          >
            <div className="service-item">
              <div className="img">
                <img
                  src="/img/fasilitas/LABOR_PK-1024.webp"
                  srcSet="/img/fasilitas/LABOR_PK-256.webp 256w,
          /img/fasilitas/LABOR_PK-512.webp 512w,
          /img/fasilitas/LABOR_PK-1024.webp 1024w"
                  sizes="(max-width: 768px) 100vw, 50vw"
                  className="img-fluid"
                  alt="LABORATORIUM PATOLOGI KLINIK"
                  width="1024"
                  height="512"
                  loading="lazy"
                  scrollPosition={scrollPosition}
                />
              </div>
              <div className="details position-relative">
                <div className="icon">
                  <Icon icon="medical-icon:i-laboratory" />
                </div>
                <Link to="/labpk" className="stretched-link">
                  <h3>LABORATORIUM PATOLOGI KLINIK</h3>
                </Link>
                <p>
                  Laboratorium yang lengkap untuk berbagai tes klinis, termasuk
                  analisis darah dan cairan tubuh, guna mendukung diagnosis dan
                  perawatan medis.
                </p>
              </div>
            </div>
          </div>

          <div
            className="col-xl-4 col-md-6"
            data-aos="zoom-in"
            data-aos-delay="700"
          >
            <div className="service-item">
              <div className="img">
                <img
                  src="/img/fasilitas/LABOR_PA-1024.webp"
                  srcSet="/img/fasilitas/LABOR_PA-256.webp 256w,
          /img/fasilitas/LABOR_PA-512.webp 512w,
          /img/fasilitas/LABOR_PA-1024.webp 1024w"
                  sizes="(max-width: 768px) 100vw, 50vw"
                  className="img-fluid"
                  alt="LABORATORIUM PATOLOGI ANATOMI"
                  width="1024"
                  height="512"
                  loading="lazy"
                  scrollPosition={scrollPosition}
                />
              </div>
              <div className="details position-relative">
                <div className="icon">
                  <Icon icon="healthicons:biochemistry-laboratory-outline" />
                </div>
                <Link to="/labpa" className="stretched-link">
                  <h3>LABORATORIUM PATOLOGI ANATOMI</h3>
                </Link>
                <p>
                  Fasilitas laboratorium untuk pemeriksaan jaringan tubuh dan
                  organ, membantu dalam diagnosis penyakit seperti kanker.
                </p>
              </div>
            </div>
          </div>
          <div
            className="col-xl-4 col-md-6"
            data-aos="zoom-in"
            data-aos-delay="700"
          >
            <div className="service-item">
              <div className="img">
                <img
                  src="/img/fasilitas/APOTIK-1024.webp"
                  srcSet="/img/fasilitas/APOTIK-256.webp 256w,
          /img/fasilitas/APOTIK-512.webp 512w,
          /img/fasilitas/APOTIK-1024.webp 1024w"
                  sizes="(max-width: 768px) 100vw, 50vw"
                  className="img-fluid"
                  alt="APOTIK"
                  width="1024"
                  height="512"
                  loading="lazy"
                  scrollPosition={scrollPosition}
                />
              </div>
              <div className="details position-relative">
                <div className="icon">
                  <Icon icon="streamline:pharmacy" />
                </div>
                <Link to="/apotik" className="stretched-link">
                  <h3>APOTIK</h3>
                </Link>
                <p>
                  Apotik rumah sakit menyediakan obat-obatan lengkap dan
                  perlengkapan medis, dengan pelayanan cepat dan profesional
                  sesuai resep dokter.
                </p>
              </div>
            </div>
          </div>
          <div
            className="col-xl-4 col-md-6"
            data-aos="zoom-in"
            data-aos-delay="700"
          >
            <div className="service-item">
              <div className="img">
                <img
                  src="/img/fasilitas/KLINIK_GIGI_MULUT-1024.webp"
                  srcSet="/img/fasilitas/KLINIK_GIGI_MULUT-256.webp 256w,
          /img/fasilitas/KLINIK_GIGI_MULUT-512.webp 512w,
          /img/fasilitas/KLINIK_GIGI_MULUT-1024.webp 1024w"
                  sizes="(max-width: 768px) 100vw, 50vw"
                  className="img-fluid"
                  alt="KLINIK GIGI DAN MULUT"
                  width="1024"
                  height="512"
                  loading="lazy"
                  scrollPosition={scrollPosition}
                />
              </div>
              <div className="details position-relative">
                <div className="icon">
                  <Icon icon="icon-park-outline:teeth" />
                </div>
                <Link to="/gigi" className="stretched-link">
                  <h3>KLINIK GIGI DAN MULUT</h3>
                </Link>
                <p>
                  Klinik yang menawarkan perawatan komprehensif kesehatan gigi,
                  termasuk pembersihan gigi, perawatan karies, hingga bedah
                  mulut dengan dokter gigi berpengalaman dan peralatan modern.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default trackWindowScroll(FeaturedServices);
